document.addEventListener('DOMContentLoaded', function () {
    const clickableElements = document.querySelectorAll('.custom-image-section__link, .custom-image-section__button');
    const overlayContainer = document.getElementById('custom-image-overlay');
    const overlayImageContent = document.getElementById('custom-image-overlay-content');
    const closeOverlayButton = document.querySelector('.custom-image-section__close');

    function updateEnlargedImages() {
        clickableElements.forEach(element => {
            const enlargedSrc = (window.innerWidth < 768 && element.getAttribute('data-enlarged-mobile')) ? element.getAttribute('data-enlarged-mobile') : element.getAttribute('data-enlarged-desktop');
            element.setAttribute('data-enlarged-src', enlargedSrc);
        });
    }

    function handleElementClick(event) {
        event.preventDefault();
        const linkHref = this.getAttribute('href');
        const enlargedSrc = this.getAttribute('data-enlarged-src');
        if (linkHref === '#' || linkHref === '') {
            if (enlargedSrc) {
                overlayImageContent.src = enlargedSrc;
                overlayContainer.style.display = 'flex';
                document.body.classList.add('no-scroll');
            }
        } else {
            window.location.href = linkHref;
        }
    }

    updateEnlargedImages();

    window.addEventListener('resize', updateEnlargedImages);

    clickableElements.forEach(element => element.addEventListener('click', handleElementClick));

    function closeOverlay() {
        overlayContainer.style.display = 'none';
        document.body.classList.remove('no-scroll');
    }

    closeOverlayButton.addEventListener('click', closeOverlay);

    overlayContainer.addEventListener('click', function (event) {
        if (event.target === overlayContainer) {
            closeOverlay();
        }
    });
});
